import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalOrderNode } from '@app/services/api/api.types';
import {
  tripCityImage,
  tripDateLabel,
  tripDestinationTitle,
  tripRouteLabel,
  tripTravelerLabel,
} from '@app/pages/trips-page/trip-card.util';

@Component({
  selector: 'trips-card',
  templateUrl: './trips-card.component.html',
  styleUrl: './trips-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripsCardComponent {
  @Input() trip: PortalOrderNode;
  @Input() banner = false;

  get title() {
    return tripDestinationTitle(this.trip);
  }

  get cityImage() {
    return tripCityImage(this.trip);
  }

  get dateLabel() {
    return tripDateLabel(this.trip);
  }

  get travelerLabel() {
    return tripTravelerLabel(this.trip);
  }

  get routeLabel() {
    return tripRouteLabel(this.trip);
  }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;

    if (img.dataset.fallback) {
      return;
    }

    img.dataset.fallback = '1';
    img.src = '/assets/images/city.svg';
  }
}
